var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 3.99999C8.25624 3.99999 8.51224 4.098 8.70724 4.29299L13.7072 9.29299C14.0982 9.68399 14.0982 10.316 13.7072 10.707L8.70724 15.707C8.31624 16.098 7.68424 16.098 7.29324 15.707C6.90224 15.316 6.90224 14.684 7.29324 14.293L11.5862 9.99999L7.29324 5.70699C6.90224 5.31599 6.90224 4.68399 7.29324 4.293C7.48824 4.098 7.74424 3.99999 8.00024 3.99999Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "e25967f17bbffdee676c5e36e52ce166.svg";
export { ForwardRef as ReactComponent };